import { resolveStorefrontFeatures } from "@loot-os/api-contract";
import { SectionSwitch, StorefrontSection } from "../components/StorefrontSection";
import { useStorefrontConfig } from "../lib/storefront";
import { useTenantRole } from "../lib/useTenantRole";
import { ChatModeration } from "./Chat";

/**
 * Chat on one storefront environment: the switch (`features.chat`, saved on flip through
 * `storefront.update` as its one key, which the server merges onto the other switches), then the
 * moderation tabs (room, reports, mutes). Off hides the chat panel and the API refuses chat reads
 * and writes; the history, the mutes and the report queue are kept and stay workable here.
 */
export function StorefrontChatPage() {
  const { can } = useTenantRole();
  const { query, update } = useStorefrontConfig();

  // Narrowing only: the layout renders a section once the same query has data.
  if (!query.data) return null;

  const { config, environment } = query.data;
  const enabled = resolveStorefrontFeatures(config.features).chat;

  return (
    <StorefrontSection
      title="Chat"
      description="A live chat room beside the storefront, where signed-in shoppers with a username talk to each other. Messages with profanity or links are refused. Off hides the panel; history, mutes and reports are kept."
      environment={environment}
      aside={
        <SectionSwitch
          id="chat-enabled"
          label="Chat"
          checked={enabled}
          disabled={update.isPending || !can("editor")}
          onCheckedChange={(checked) => update.mutate({ features: { chat: checked } })}
        />
      }
    >
      <ChatModeration />
    </StorefrontSection>
  );
}
